<div class="grid-container margin-top">
  @if (!isLoading) {
    <form [formGroup]="form">
      @if (!isInputting && !isConfirming) {
        <div class="grid-x">
          <div class="cell large-8 medium-8 small-9 bold text-align-right padding-top">
            Is this new API# assignment for a UIC well that is to be permitted and assigned an API# in RBDMS?<span [ngClass]="{ 'red': form?.get('UIC')?.invalid }">*</span>
          </div>
          <div class="cell large-4 medium-4 small-3 padding-left padding-top">
            <select formControlName="UIC" (ngModelChange)="uicChanged($event)">
              <option value="">--Select--</option>
              <option value="no">No</option>
              <option value="yes">Yes</option>
            </select>
          </div>
          @if (isUIC === true) {
            <div class="cell large-6 medium-6 small-6 padding-right text-align-center bold">
              Please look up the Organization the API number is being reserved for using:
            </div>
            <div class="cell large-6 medium-6 small-6 text-align-center bold">
              Verify the found organization information is correct:
            </div>
            <div class="cell large-3 medium-3 small-3 text-align-right bold">
              Organization Name:
            </div>
            <div class="cell large-3 medium-3 small-3 padding-left">
              <input type="text" formControlName="organizationName" />
            </div>
            <div class="cell large-3 medium-3 small-3 text-align-right bold">
              Organization Name:
            </div>
            <div class="cell large-3 medium-3 small-3 padding-left">
              {{foundOrganizationName}}
            </div>
            <div class="cell large-3 medium-3 small-3 text-align-right bold">
              -OR- RICS Organization #:
            </div>
            <div class="cell large-3 medium-3 small-3 padding-left">
              <input type="text" formControlName="ricsOrganizationId" />
            </div>
            <div class="cell large-3 medium-3 small-3 text-align-right bold">
              RICS Organization Id:
            </div>
            <div class="cell large-3 medium-3 small-3 padding-left">
              {{foundRicsOrganizationId}}
            </div>
            <div class="cell large-3 medium-3 small-3 text-align-right bold">
              -OR- RBDMS Owner #:
            </div>
            <div class="cell large-3 medium-3 small-3 padding-left">
              <input type="text" formControlName="rbdmsOwnerNumber" />
            </div>
            <div class="cell large-3 medium-3 small-3 text-align-right bold">
              RBDMS Owner Number:
            </div>
            <div class="cell large-3 medium-3 small-3 padding-left">
              {{foundRbdmsOwnerNumber}}
            </div>
            <div class="cell large-6 medium-6 small-6 text-align-right padding-right">
              <span class="padding-right-small">
                <button class="button" (click)="validateOrganization()">Verify Organization</button>
              </span>
              <span class="padding-left-small">
                <button class="button" (click)="searchDifferentOrganization()" [disabled]="!organizationSearched">Search for a Different Organization</button>
              </span>
            </div>
            <div class="cell large-6 medium-6 small-6 text-align-center padding-left">
              <div class="checkbox">
                <input class="show-for-sr" id="organizationConfirmed" type="checkbox" formControlName="organizationConfirmed" />
                <label for="organizationConfirmed">
                  <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span> The found organization is correct.
                </label>
              </div>
              @if (organizationSearched && organizationNotFound) {
                <span class="red bold">
                  Organization not found using the information provided.
                </span>
              }
            </div>
            <div class="cell large-2 medium-2 small-6 bold padding-right text-align-right">
              Well Type:<span [ngClass]="{ 'red' : form?.get('wellType')?.invalid }">*</span>
            </div>
            <div class="cell large-4 medium-4 small-6">
              <select formControlName="wellType" (ngModelChange)="updateAvailableDescriptions($event)">
                @for (opt of wellTypes; track opt) {
                  <option [value]="opt.Code">{{opt.Definition}}</option>
                }
              </select>
            </div>
            <div class="cell large-2 medium-4 small-6 bold padding-right text-align-right">
              Well Type Description:
            </div>
            <div class="cell large-4 medium-4 small-6">
              <select formControlName="wellTypeDescription">
                @for (opt of availableWellTypeDescriptions; track opt) {
                  <option [value]="opt.id">{{opt.text}}</option>
                }
              </select>
            </div>
            <div class="cell large-8 medium-8 small-9 text-align-right bold">
              County the well will be in:<span [ngClass]="{ 'red': form.get('county')?.invalid }">*</span>
            </div>
            <div class="cell large-4 medium-4 small-3 padding-left">
              <select formControlName="county">
                @for (item of apiList; track item) {
                  <option [ngValue]="item.county">{{item.county.name}}</option>
                }
              </select>
            </div>
            <div class="cell large-8 medium-8 small-9 text-align-right bold">
              What is the Next available 2-Series Hole Number for the County in RBDMS?:<span [ngClass]="{ 'red': form.get('holeNumber')?.invalid }">*</span>
            </div>
            <div class="cell large-4 medium-4 small-3 padding-left">
              <input type="number" formControlName="holeNumber" placeholder="2xxxx" max="99999" min="20000" />
            </div>
            <div class="cell large-8 medium-8 small-9 text-align-right">
              @if (holeNumberAvailable) {
                Projected API # to be reserved: #{{formattedAPI}}.
              } @else {
                @if (holeNumberAvailable == false) {
                  <span><svg-icon icon="icon-alert" class="small"></svg-icon><span class="padding-left padding-right-small red bold">Hole Number currently in use.</span></span>
                }
              }
            </div>
            <div class="cell large-4 medium-4 small-3 padding-left">
              <button class="button" (click)="confirmGenerate()" [disabled]="disableGenerate">Generate</button>
            </div>
          }
          @if (isUIC === false) {
            <div class="cell large-8 medium-8 small-9 bold text-align-right">
              Is this an Historic or Orphan well that needs a 6-Series API #?<span [ngClass]="{ 'red': form?.get('historic')?.invalid }">*</span>
            </div>
            <div class="cell large-4 medium-4 small-3 padding-left">
              <select formControlName="historic" (ngModelChange)="historicChanged($event)">
                <option value="">--Select--</option>
                <option value="no">No</option>
                <option value="yes">Yes</option>
              </select>
            </div>
            @if (isHistoric) {
              <div class="cell large-8 medium-8 small-9 text-align-right bold">
                County the well will be in:<span [ngClass]="{ 'red': form.get('county')?.invalid }">*</span>
              </div>
              <div class="cell large-4 medium-4 small-3 padding-left">
                <select formControlName="county">
                  @for (item of apiList; track item) {
                    <option [ngValue]="item.county">{{item.county.name}}</option>
                  }
                </select>
              </div>
              <div class="cell large-8 medium-8 small-9 text-align-right bold">
                What is the Next available 6-Series Hole Number for the County in RBDMS?:<span [ngClass]="{ 'red': form.get('holeNumber')?.invalid }">*</span>
              </div>
              <div class="cell large-4 medium-4 small-3 padding-left">
                <input type="number" formControlName="holeNumber" placeholder="6xxxx" max="99999" min="60000" />
              </div>
              @if (county != null && holeNumberInValidRange) {
                <div class="cell large-8 medium-8 small-8 text-align-right">
                  @if (holeNumberAvailable) {
                    Projected API # to be reserved: {{formattedAPI}}.
                  } @else {
                    @if (holeNumberAvailable == false) {
                      <span><svg-icon icon="icon-alert" class="small"></svg-icon><span class="padding-left padding-right-small red bold">Hole Number currently in use.</span></span>
                    }
                  }
                </div>
                <div class="cell large-4 medium-4 small-3 padding-left">
                  <button class="button" (click)="confirmOrphanAPI()" [disabled]="formInvalid || !holeNumberAvailable">Confirm and Input Orphan Well Data</button>
                </div>
              }
            }
          }
        </div>
      }
      @if (isInputting) {
        <div class="grid-x" formGroupName="inputForm">
          <div class="cell large-12 medium-12 small-12 bold text-align-center">
            Please provide the following information about the well to be created as API #{{pendingAPIToReserve}}.  Required fields are marked with an <span [ngClass]="{ 'red': form?.get('inputForm')?.invalid }">*</span>.
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            A Number:
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="aNumber" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Pepper Number:
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="pepperNumber" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Owner Name:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('ownerName')?.invalid }">*</span>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="ownerName" (blur)="validateOrphanOwner('name')" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            RICS Owner Number:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('ownerNumber')?.invalid }">*</span>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="ownerNumber" (blur)="validateOrphanOwner('id')" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Well Name:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('wellName')?.invalid }">*</span>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="wellName" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Well Number:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('wellNumber')?.invalid }">*</span>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="wellNumber" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
            <span class="bold">County:</span><help-text [helpText]="'County was pre-selected based on previously input values.  To change, return to the previous screen.'"></help-text>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <select formControlName="county">
              @for (item of apiList; track item) {
                <option [ngValue]="item.county">{{item.county.name}}</option>
              }
            </select>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
            <span class="bold">Civil Township:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('civilTownship')?.invalid }">*</span></span><help-text [helpText]="'Civil Township will be validated via GIS.'"></help-text>
          </div>
          <div class="cell large-3 medium-3 small-6">
            <div class="cell small-8 medium-8 large-8">
              <select id="township" formControlName="civilTownship">
                @for (t of townshipList; track t) {
                  <option [ngValue]="t">{{t}}</option>
                }
              </select>
            </div>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Slant:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('slant')?.invalid }">*</span>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <select id="slant" formControlName="slant" (ngModelChange)="slantChanged($event)">
              @for (item of directionOptions; track item) {
                <option [ngValue]="item.id">{{item.text}}</option>
              }
            </select>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
            <span class="bold">Section:</span><help-text [helpText]="'Section will be validated via GIS.'"></help-text>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="section" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
            <span class="bold">Lot:</span><help-text [helpText]="'Lot will be validated via GIS.'"></help-text>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="lot" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
            <span class="bold">Tract:</span><help-text [helpText]="'Tract will be validated via GIS.'"></help-text>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="tract" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Allotment:
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="allotment" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Original Survey:
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="originalSurvey" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Fraction:
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="fraction" />
          </div>
          <div class="cell large-6 medium-6 small-12">&nbsp;</div>
          <div class="cell large-5 medium-5 small-6 text-align-right bold">
            Surface Coordinates:
          </div>
          <div class="cell large-7 medium-7 small-6 shrink-font">
            <span class="padding-left padding-right"><button class="button" (click)="validateCoordinates(pointTypes.WellHead)" [disabled]="form?.get('inputForm')?.get('surfaceLatitude')?.invalid || form?.get('inputForm')?.get('surfaceLongitude')?.invalid">Validate Surface Coordinates in GIS</button></span>
            @if (form?.get('inputForm').get('countyVerified')?.value === true) {
              <span class="green bold">Surface Coordinates have been verified.</span>
            } @else {
              <span class="red bold shrink-font">Surface Coordinates have NOT been verified.</span>
            }
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-left-large padding-right bold">
            Latitude:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('surfaceLatitude')?.invalid }">*</span>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="number" formControlName="surfaceLatitude" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Longitude:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('surfaceLongitude')?.invalid }">*</span>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="number" formControlName="surfaceLongitude" />
          </div>
          @if (isHorizontal) {
            <div class="cell large-5 medium-5 small-6 bold text-align-right">First Take Point Coordinates:</div>
            <div class="cell large-7 medium-7 small-6">
              <span class="padding-left padding-right"><button class="button" (click)="validateCoordinates(pointTypes.Toe)" [disabled]="form?.get('inputForm')?.get('firstTakePointLatitude')?.invalid || form?.get('inputForm')?.get('firstTakePointLongitude')?.invalid">Validate First Take Point Coordinates in GIS</button></span>
              @if (form?.get('inputForm').get('firstTakeVerified')?.value === true) {
                <span class="green bold shrink-font">First Take Point Coordinates have been verified.</span>
              } @else {
                <span class="red bold shrink-font">First Take Point Coordinates have NOT been verified.</span>
              }
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-left-large padding-right bold">
              Latitude:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('firstTakePointLatitude')?.invalid }">*</span>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="number" formControlName="firstTakePointLatitude" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
              Longitude:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('firstTakePointLongitude')?.invalid }">*</span>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="number" formControlName="firstTakePointLongitude" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">County:</span><help-text [helpText]="'County will be validated via GIS.'"></help-text>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <select formControlName="firstTakeCounty">
                @for (item of apiList; track item) {
                  <option [ngValue]="item.county">{{item.county.name}}</option>
                }
              </select>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Civil Township:</span><help-text [helpText]="'Civil Township will be validated via GIS.'"></help-text>
            </div>
            <div class="cell large-3 medium-3 small-6">
              <div class="cell small-8 medium-8 large-8">
                <select id="township" formControlName="firstTakeTownship">
                  @for (t of townshipList; track t) {
                    <option [ngValue]="t">{{t}}</option>
                  }
                </select>
              </div>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Section:</span><help-text [helpText]="'Section will be validated via GIS.'"></help-text>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="text" formControlName="firstTakeSection" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Lot:</span><help-text [helpText]="'Lot will be validated via GIS.'"></help-text>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="text" formControlName="firstTakeLot" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Tract:</span><help-text [helpText]="'Tract will be validated via GIS.'"></help-text>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="text" formControlName="firstTakeTract" />
            </div>
            <div class="cell large-6 medium-6 small-6 text-align-right padding-right bold">
              &nbsp;
            </div>
            <div class="cell large-5 medium-5 small-6 bold text-align-right">Last Take Point Coordinates:</div>
            <div class="cell large-7 medium-7 small-6">
              <span class="padding-left padding-right"><button class="button" (click)="validateCoordinates(pointTypes.Heel)" [disabled]="form?.get('inputForm')?.get('lastTakePointLatitude')?.invalid || form?.get('inputForm')?.get('lastTakePointLongitude')?.invalid">Validate Last Take Point Coordinates in GIS</button></span>
              @if (form?.get('inputForm').get('lastTakeVerified')?.value === true) {
                <span class="green bold shrink-font">Last Take Point Coordinates have been verified.</span>
              } @else {
                <span class="red bold shrink-font">Last Take Point Coordinates have NOT been verified.</span>
              }
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-left-large padding-right bold">
              Latitude:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('lastTakePointLatitude')?.invalid }">*</span>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="number" formControlName="lastTakePointLatitude" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
              Longitude:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('lastTakePointLongitude')?.invalid }">*</span>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="number" formControlName="lastTakePointLongitude" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">County:</span><help-text [helpText]="'County will be validated via GIS.'"></help-text>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <select formControlName="lastTakeCounty">
                @for (item of apiList; track item) {
                  <option [ngValue]="item.county">{{item.county.name}}</option>
                }
              </select>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Civil Township:</span><help-text [helpText]="'Civil Township will be validated via GIS.'"></help-text>
            </div>
            <div class="cell large-3 medium-3 small-6">
              <div class="cell small-8 medium-8 large-8">
                <select id="township" formControlName="lastTakeTownship">
                  @for (t of townshipList; track t) {
                    <option [ngValue]="t">{{t}}</option>
                  }
                </select>
              </div>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Section:</span><help-text [helpText]="'Section will be validated via GIS.'"></help-text>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="text" formControlName="lastTakeSection" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Lot:</span><help-text [helpText]="'Lot will be validated via GIS.'"></help-text>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="text" formControlName="lastTakeLot" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Tract:</span><help-text [helpText]="'Tract will be validated via GIS.'"></help-text>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="text" formControlName="lastTakeTract" />
            </div>
            <div class="cell large-6 medium-6 small-6 text-align-right padding-right bold">
              &nbsp;
            </div>
          }
          @if (isDirectional || isHorizontal) {
            <div class="cell large-5 medium-5 small-6 bold text-align-right">Target Point Coordinates:</div>
            <div class="cell large-7 medium-7 small-6">
              <span class="padding-left padding-right"><button class="button" (click)="validateCoordinates(pointTypes.Target)" [disabled]="form?.get('inputForm')?.get('targetLatitude')?.invalid || form?.get('inputForm')?.get('targetLongitude')?.invalid">Validate Target Coordinates in GIS</button></span>
              @if (form?.get('inputForm').get('targetVerified')?.value === true) {
                <span class="green bold shrink-font">Target Coordinates have been verified.</span>
              } @else {
                <span class="red bold shrink-font">Target Coordinates have NOT been verified.</span>
              }
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-left-large padding-right bold">
              Latitude:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('targetLatitude')?.invalid }">*</span>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="number" formControlName="targetLatitude" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
              Longitude:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('targetLongitude')?.invalid }">*</span>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="number" formControlName="targetLongitude" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">County:</span><help-text [helpText]="'County will be validated via GIS.'"></help-text>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <select formControlName="targetCounty">
                @for (item of apiList; track item) {
                  <option [ngValue]="item.county">{{item.county.name}}</option>
                }
              </select>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Civil Township:</span><help-text [helpText]="'Civil Township will be validated via GIS.'"></help-text>
            </div>
            <div class="cell large-3 medium-3 small-6">
              <div class="cell small-8 medium-8 large-8">
                <select id="township" formControlName="targetTownship">
                  @for (t of townshipList; track t) {
                    <option [ngValue]="t">{{t}}</option>
                  }
                </select>
              </div>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Section:</span><help-text [helpText]="'Section will be validated via GIS.'"></help-text>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="text" formControlName="targetSection" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Lot:</span><help-text [helpText]="'Lot will be validated via GIS.'"></help-text>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="text" formControlName="targetLot" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Tract:</span><help-text [helpText]="'Tract will be validated via GIS.'"></help-text>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="text" formControlName="targetTract" />
            </div>
            <div class="cell large-6 medium-6 small-6 text-align-right padding-right bold">
              &nbsp;
            </div>
          }
          <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
            Well Status:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('wellStatus')?.invalid }">*</span>
          </div>
          <div class="cell large-3 medium-3 small-6">
            <select formControlName="wellStatus">
              @for (opt of wellStatus; track opt) {
                <option [value]="opt.Code">{{opt.Definition}}</option>
              }
            </select>
          </div>
          <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
            Well Status Reason:
          </div>
          <div class="cell large-3 medium-3 small-6">
            <select formControlName="statusReason">
              @for (opt of wellStatusReason; track opt) {
                <option [value]="opt.Code">{{opt.Definition}}</option>
              }
            </select>
          </div>
          <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
            Well Type:
          </div>
          <div class="cell large-3 medium-3 small-6">
            <select formControlName="wellType">
              @for (opt of wellTypes; track opt) {
                <option [value]="opt.Code">{{opt.Definition}}</option>
              }
            </select>
          </div>
          <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
            Well Type Description:
          </div>
          <div class="cell large-3 medium-3 small-6">
            <select formControlName="wellTypeDescription">
              @for (opt of wellTypeDescription; track opt) {
                <option [value]="opt.Code">{{opt.Definition}}</option>
              }
            </select>
          </div>
          <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
            Well Disposition:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('wellDisposition')?.invalid }">*</span>
          </div>
          <div class="cell large-3 medium-3 small-3">
            <select formControlName="wellDisposition">
              @for (opt of wellDisposition; track opt) {
                <option [value]="opt.Code">{{opt.Definition}}</option>
              }
            </select>
          </div>
          <div class="cell large-6 medium-6 small-12">&nbsp;</div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Spudded Date:
          </div>
          <div class="cell large-3 medium-3 small-6">
            <common-date-picker [id]="'spuddedDate'" (dateUpdated)="spuddedDateChanged($event)"></common-date-picker>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Total Depth Date:
          </div>
          <div class="cell large-3 medium-3 small-6">
            <common-date-picker [id]="'totalDepthDate'" (dateUpdated)="totalDepthDateChanged($event)"></common-date-picker>
          </div>
          <div class="cell large-12 medium-12 small-12">
            <reservation-notes [label]="'Comments'" [notes]="notes" [enabled]="true" (errorOccurred)="logError($event)" (noteAdded)="addNote($event)" (noteDeleted)="deleteNote($event)"></reservation-notes>
          </div>
          <div class="cell large-12 medium-12 small-12 text-align-center margin-top">
            <span class="padding-right">
              <button class="button" (click)="backToSelection()">Previous</button>
            </span>
            <span class="padding-left">
              <button class="button" (click)="confirmInputs()" [disabled]="formInvalid || ownerNumberNotOnFile">Next</button>
            </span>
          </div>
        </div>
      }
      @if (isConfirming) {
        <div class="grid-x" formGroupName="inputForm">
          <div class="cell large-12 medium-12 small-12 bold text-align-center">
            Please confirm the well information is correct before selecting the Assign API# button.  <span class="bold red">Proposed API #{{pendingAPIToReserve}}.</span>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            A Number:
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="aNumber" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Pepper Number:
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="pepperNumber" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Owner Name:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('ownerName')?.invalid }">*</span>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="ownerName" />
            @if (ownerNameMismatch != null) {
              <small class="red italic">{{ownerNameMismatch}}</small>
            }
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
            <span class="bold">Owner Number:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('ownerNumber')?.invalid }">*</span></span><help-text [helpText]="'To be considered valid, the owner number must exist in either RICS or RBDMS.'"></help-text>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="ownerNumber" />
            @if (ownerNumberNotOnFile != null) {
              <small class="red italic">{{ownerNumberNotOnFile}}</small>
            }
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Well Name:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('wellName')?.invalid }">*</span>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="wellName" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Well Number:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('wellNumber')?.invalid }">*</span>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="wellNumber" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
            <span class="bold">County:</span><help-text [helpText]="'County was pre-selected based on previously input values.  To change, return to the previous screen.'"></help-text>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <select formControlName="county">
              @for (item of apiList; track item) {
                <option [ngValue]="item.county">{{item.county.name}}</option>
              }
            </select>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
            <span class="bold">Civil Township:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('civilTownship')?.invalid }">*</span></span>
          </div>
          <div class="cell large-3 medium-3 small-6">
            <div class="cell small-8 medium-8 large-8">
              <select id="township" formControlName="civilTownship">
                @for (t of townshipList; track t) {
                  <option [ngValue]="t">{{t}}</option>
                }
              </select>
            </div>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Slant:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('slant')?.invalid }">*</span>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <select id="slant" formControlName="slant" (ngModelChange)="slantChanged($event)">
              @for (item of directionOptions; track item) {
                <option [ngValue]="item.id">{{item.text}}</option>
              }
            </select>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Section:
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="section" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Lot:
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="lot" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Tract:
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="tract" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Allotment:
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="allotment" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Original Survey:
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="originalSurvey" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Fraction:
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="text" formControlName="fraction" />
          </div>
          <div class="cell large-6 medium-6 small-12">&nbsp;</div>
          <div class="cell large-12 medium-12 small-12 text-align-center">
            <span class="bold padding-right">Surface Coordinates:</span>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-left-large padding-right bold">
            Latitude:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('surfaceLatitude')?.invalid }">*</span>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="number" formControlName="surfaceLatitude" />
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Longitude:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('surfaceLongitude')?.invalid }">*</span>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-left">
            <input type="number" formControlName="surfaceLongitude" />
          </div>
          @if (isHorizontal) {
            <div class="cell large-12 medium-12 small-12 bold text-align-center">First Take Point Coordinates:</div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-left-large padding-right bold">
              Latitude:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('firstTakePointLatitude')?.invalid }">*</span>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="number" formControlName="firstTakePointLatitude" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
              Longitude:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('firstTakePointLongitude')?.invalid }">*</span>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="number" formControlName="firstTakePointLongitude" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">County:</span><help-text [helpText]="'County will be validated via GIS.'"></help-text>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <select formControlName="firstTakeCounty">
                @for (item of apiList; track item) {
                  <option [ngValue]="item.county">{{item.county.name}}</option>
                }
              </select>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Civil Township:</span><help-text [helpText]="'Civil Township will be validated via GIS.'"></help-text>
            </div>
            <div class="cell large-3 medium-3 small-6">
              <div class="cell small-8 medium-8 large-8">
                <select id="township" formControlName="firstTakeTownship">
                  @for (t of townshipList; track t) {
                    <option [ngValue]="t">{{t}}</option>
                  }
                </select>
              </div>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Section:</span><help-text [helpText]="'Section will be validated via GIS.'"></help-text>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="text" formControlName="firstTakeSection" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Lot:</span><help-text [helpText]="'Lot will be validated via GIS.'"></help-text>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="text" formControlName="firstTakeLot" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Tract:</span><help-text [helpText]="'Tract will be validated via GIS.'"></help-text>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="text" formControlName="firstTakeTract" />
            </div>
            <div class="cell large-6 medium-6 small-6 text-align-right padding-right bold">
              &nbsp;
            </div>
            <div class="cell large-5 medium-5 small-6 bold text-align-right">Last Take Point Coordinates:</div>
            <div class="cell large-7 medium-7 small-6">
              <span class="padding-left padding-right"><button class="button" (click)="validateCoordinates(pointTypes.Heel)" [disabled]="form?.get('inputForm')?.get('lastTakePointLatitude')?.invalid || form?.get('inputForm')?.get('lastTakePointLongitude')?.invalid">Validate Last Take Point Coordinates in GIS</button></span>
              @if (form?.get('inputForm').get('lastTakeVerified')?.value === true) {
                <span class="green bold shrink-font">Last Take Point Coordinates have been verified.</span>
              } @else {
                <span class="red bold shrink-font">Last Take Point Coordinates have NOT been verified.</span>
              }
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-left-large padding-right bold">
              Latitude:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('lastTakePointLatitude')?.invalid }">*</span>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="number" formControlName="lastTakePointLatitude" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
              Longitude:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('lastTakePointLongitude')?.invalid }">*</span>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="number" formControlName="lastTakePointLongitude" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">County:</span>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <select formControlName="lastTakeCounty">
                @for (item of apiList; track item) {
                  <option [ngValue]="item.county">{{item.county.name}}</option>
                }
              </select>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Civil Township:</span>
            </div>
            <div class="cell large-3 medium-3 small-6">
              <div class="cell small-8 medium-8 large-8">
                <select id="township" formControlName="lastTakeTownship">
                  @for (t of townshipList; track t) {
                    <option [ngValue]="t">{{t}}</option>
                  }
                </select>
              </div>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Section:</span>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="text" formControlName="lastTakeSection" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Lot:</span>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="text" formControlName="lastTakeLot" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Tract:</span>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="text" formControlName="lastTakeTract" />
            </div>
            <div class="cell large-6 medium-6 small-6 text-align-right padding-right bold">
              &nbsp;
            </div>
          }
          @if (isDirectional || isHorizontal) {
            <div class="cell large-12 medium-12 small-12 bold text-align-center">Target Point Coordinates:</div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-left-large padding-right bold">
              Latitude:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('targetLatitude')?.invalid }">*</span>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="number" formControlName="targetLatitude" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
              Longitude:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('targetLongitude')?.invalid }">*</span>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="number" formControlName="targetLongitude" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">County:</span>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <select formControlName="targetCounty">
                @for (item of apiList; track item) {
                  <option [ngValue]="item.county">{{item.county.name}}</option>
                }
              </select>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Civil Township:</span>
            </div>
            <div class="cell large-3 medium-3 small-6">
              <div class="cell small-8 medium-8 large-8">
                <select id="township" formControlName="targetTownship">
                  @for (t of townshipList; track t) {
                    <option [ngValue]="t">{{t}}</option>
                  }
                </select>
              </div>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Section:</span>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="text" formControlName="targetSection" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Lot:</span>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="text" formControlName="targetLot" />
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-right padding-right">
              <span class="bold">Tract:</span>
            </div>
            <div class="cell large-3 medium-3 small-6 text-align-left">
              <input type="text" formControlName="targetTract" />
            </div>
            <div class="cell large-6 medium-6 small-6 text-align-right padding-right bold">
              &nbsp;
            </div>
          }
          <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
            Well Status:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('wellStatus')?.invalid }">*</span>
          </div>
          <div class="cell large-3 medium-3 small-6">
            <select formControlName="wellStatus">
              @for (opt of wellStatus; track opt) {
                <option [value]="opt.Code">{{opt.Definition}}</option>
              }
            </select>
          </div>
          <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
            Well Status Reason:
          </div>
          <div class="cell large-3 medium-3 small-6">
            <select formControlName="statusReason">
              @for (opt of wellStatusReason; track opt) {
                <option [value]="opt.Code">{{opt.Definition}}</option>
              }
            </select>
          </div>
          <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
            Well Type:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('wellType')?.invalid }">*</span>
          </div>
          <div class="cell large-3 medium-3 small-6">
            <select formControlName="wellType">
              @for (opt of wellTypes; track opt) {
                <option [value]="opt.Code">{{opt.Definition}}</option>
              }
            </select>
          </div>
          <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
            Well Type Description:
          </div>
          <div class="cell large-3 medium-3 small-6">
            <select formControlName="wellTypeDescription">
              @for (opt of wellTypeDescription; track opt) {
                <option [value]="opt.Code">{{opt.Definition}}</option>
              }
            </select>
          </div>
          <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
            Well Disposition:<span [ngClass]="{ 'red' : form?.get('inputForm')?.get('wellDisposition')?.invalid }">*</span>
          </div>
          <div class="cell large-3 medium-3 small-3">
            <select formControlName="wellDisposition">
              @for (opt of wellDisposition; track opt) {
                <option [value]="opt.Code">{{opt.Definition}}</option>
              }
            </select>
          </div>
          <div class="cell large-6 medium-6 small-12">&nbsp;</div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Spudded Date:
          </div>
          <div class="cell large-3 medium-3 small-6">
            <common-date-picker [disabled]="true" [initialDate]="spuddedDate"></common-date-picker>
          </div>
          <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
            Total Depth Date:
          </div>
          <div class="cell large-3 medium-3 small-6">
            <common-date-picker [disabled]="true" [initialDate]="totalDepthDate"></common-date-picker>
          </div>
          <div class="cell large-12 medium-12 small-12">
            <reservation-notes [label]="'Comments'" [notes]="notes" [enabled]="false" (errorOccurred)="logError($event)" (noteAdded)="addNote($event)" (noteDeleted)="deleteNote($event)"></reservation-notes>
          </div>
        </div>
        <div class="grid-x">
          <div class="cell large-12 medium-12 small-12 text-align-center">
            <div class="checkbox">
              <input class="show-for-sr no-margin vertical-align-middle" id="dataIsCorrect" type="checkbox" formControlName="dataIsCorrect" />
              <label for="dataIsCorrect" class="minor-margin-right display-inline-block">
                <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span> The above data for the orphan/historic well to be recorded as API #{{pendingAPIToReserve}} is correct.
              </label>
            </div>
          </div>
          <div class="cell large-12 medium-12 small-12 text-align-center">
            <span class="padding-right">
              <button class="button" (click)="backToInputs()">Make Changes</button>
            </span>
            <span class="padding-left">
              <button class="button" (click)="submitOrphanWell()" [disabled]="form?.invalid">Assign API #</button>
            </span>
          </div>
        </div>
      }
    </form>
  } @else {
    <div class="cell large-12 medium-12 small-12">
      <text-loader [run]="isLoading" [text]="'Loading Data'" [tickType]="'.'" [interval]="2000"></text-loader>
    </div>
  }

</div>










